"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFocusTrapInstance = exports.focusTrapDeactivate = exports.focusTrapActivate = void 0;
var currentFocusInstance;

var setFocusTrapInstance = function setFocusTrapInstance(ref) {
  if (ref) {
    currentFocusInstance = ref.focusTrap;
  }
};

exports.setFocusTrapInstance = setFocusTrapInstance;

var focusTrapActivate = function focusTrapActivate() {
  if (currentFocusInstance) {
    currentFocusInstance.activate();
  }
};

exports.focusTrapActivate = focusTrapActivate;

var focusTrapDeactivate = function focusTrapDeactivate() {
  if (currentFocusInstance) {
    currentFocusInstance.deactivate({
      onDeactivate: function onDeactivate() {
        return null;
      },
      onPostDeactivate: function onPostDeactivate() {
        return null;
      }
    });
  }
};

exports.focusTrapDeactivate = focusTrapDeactivate;